export default __webpack_public_path__ + "static/media/produits_sains-3.0a1cb209.png";